const Joi = require("joi");

const otpSchema = (data) => {
  const schema = Joi.object({
    otp: Joi.string()
      .length(6)
      .alphanum() // Allows A-Z, a-z, 0-9
      .required()
      .messages({
        "string.base": "One-Time Code must be a string",
        "string.length": "One-Time Code must be exactly 6 characters",
        "string.alphanum":
          "One-Time Code must contain only letters and numbers",
        "string.empty": "One-Time Code is not allowed to be empty",
        "any.required": "One-Time Code is required",
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = otpSchema;
